// src/features/company/components/CompanyBannerV2.tsx
import React from 'react';
import { View, Image } from 'react-native';
import Typography from 'src/components/Text/Text';
import TourWrapper from 'src/components/TourWrapper/TourWrapper';
import { styles } from '../../screens/CompanyLandingScreen/CompanyLandingScreen.styles';

// (You'll need to add these assets to /src/assets)
import truck from 'src/assets/bannerTruck.png';
import checkIcon from 'src/assets/checkCircle.png';
import ctaArrow from 'src/assets/ctaArrow.png';

const CompanyBannerV2: React.FC = () => (
  <View>
    <TourWrapper tourId="company-banner">
      <View style={styles.bannerV2}>
        <View style={styles.bannerV2Content}>
          {/* Headline */}
          <Typography variant="h2" style={styles.bannerV2Title}>
            <Typography variant="h2" style={styles.bannerV2Title}>
              Why Choose{' '}
            </Typography>
            <Typography variant="h2" style={styles.bannerV2TitleHighlight}>
              Trucker Path Insurance?
            </Typography>
          </Typography>

          {/* Bullet list */}
          <View style={styles.bannerV2List}>
            {[
              'Hassle-Free Quotes in Under 5 Minutes',
              'Competitive Rates, Saving You $$$',
              'Dedicated Support from Industry Pros',
            ].map((text) => (
              <View key={text} style={styles.bannerV2ListItem}>
                <Image source={checkIcon} style={styles.bannerV2ListIcon} />
                <Typography variant="title1" style={styles.bannerV2ListText}>
                  {text}
                </Typography>
              </View>
            ))}
          </View>
        </View>
        {/* Truck illustration (floats down in the corner) */}
        <Image source={truck} style={styles.bannerV2Truck} resizeMode="contain" />
      </View>
    </TourWrapper>
    {/* CTA bar */}
    <View style={styles.bannerV2Cta}>
      <Typography variant="h2" style={styles.bannerV2CtaText}>
        Get Started by Confirming{'\n'}Your Business Info Below
      </Typography>
      <Image source={ctaArrow} style={styles.bannerV2CtaIcon} />
    </View>
  </View>
);

export default CompanyBannerV2;
